/**
 * Converte o valor guardado no formulário (DD/MM/AAAA ou ISO) na data local que o DatePicker mostra.
 *
 * A jornada nova grava o nascimento como meia-noite UTC (`1968-01-25T00:00:00.000Z`). `new Date(iso)` leva
 * isso para o fuso do navegador e, no Brasil (UTC-3), vira 24/01 às 21h: o campo mostrava um dia antes.
 * Por isso a data de calendário (AAAA-MM-DD) é lida direto da string, sem passar por fuso.
 */
export function parseDateValue(value: string): Date | null {
  if (!value) return null;

  if (value.includes('/')) {
    const [day, month, year] = value.split('/').map(Number);
    return calendarDate(year, month, day);
  }

  const isoDay = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (isoDay) {
    return calendarDate(Number(isoDay[1]), Number(isoDay[2]), Number(isoDay[3]));
  }

  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

function calendarDate(year: number, month: number, day: number): Date | null {
  if (!year || !month || !day) return null;
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}
